<div tabindex="0" class="me-register-voucher-card" *ngIf="data">
    <div class="me-register-voucher-card__header">
        {{data.title}}
    </div>
    <div class="me-register-voucher-card__description">
        {{data.text}}
    </div>
    <form [formGroup]="form" novalidate class="mat-form">
        <div class="me-form-input-group">
            <div class="me-form-input" [class.error]="errorInput">
                <label class="me-form-input__label">{{ data.inputLabel }}</label>
                <input formControlName="voucher" class="me-form-input__input" />
            </div>
            <small class="me-form-input__error" [class.hidden]="!errorInput">
                {{ data.errorText | translate }}
            </small>
        </div>
    </form>
    <div class="me-register-voucher-card__button">
        <button class="btn btn--primary" (click)="checkVoucher(form.value)">
            <ng-container *ngIf="form.controls.voucher.value == ''">
                {{ 'Skip' | translate}}
            </ng-container>
            <ng-container *ngIf="form.controls.voucher.value != ''">
                {{ 'Validate' | translate}}
            </ng-container>
        </button>
    </div>
</div>